<template>
  <div>
    <commBanner :obj="obj" ></commBanner>
    <titleHead :headTitle="obj.title" :headText="obj.content"></titleHead>
    <div class="environmental_housekeeper_content warp">
      <div class="environmental_housekeeper_left">
        <img
          src="../assets/images/Environmental_housekeeper_service.png"
          alt=""
        />
        <p>{{kepp.title}}</p>
        <span>{{kepp.des}}</span>
      </div>
      <div class="environmental_housekeeper_right">
        <img src="../assets/images/environmental_housekeeper_bg.jpg" alt="" />
      </div>
    </div>
    <div class="environmental_service" id="section1">
      <div class="environmental_service_top">
        <h3>环保服务</h3>
        <p>Environmental services</p>
        <div class="environmental_service_structure">
          <ul>
            <li>环境报告及文案编制</li>
            <li>环保核查</li>
            <li>环保台账</li>
            <li>环保监测</li>
            <li>环保培训</li>
            <li>环保问题诊断</li>
          </ul>
          <div class="environmental_service_line"></div>
          <ul>
            <li>环境影响评价</li>
            <li>清洁生产</li>
            <li>排污许可</li>
            <li>环境应急预案</li>
            <li>上市公司环境信息披露</li>
            <li>环保竣工验收</li>
            <li>危废管理</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="environment_protection_list warp" id="section2">
      <h3>环保工程</h3>
      <p>快速对接专业施工团队，环境工程一站式服务</p>
      <ul>
        <li class="animated  fadeInLeftBig">
          <img src="../assets/images/icons_1.png" alt="" />
          <span>环保工程设计</span>
        </li>
        <li class="animated  fadeInLeftBig">
          <img src="../assets/images/icons_2.png" alt="" />
          <span>环保工程施工</span>
        </li>
        <li class="animated  fadeIn">
          <img src="../assets/images/icons_3.png" alt="" />
          <span>环保工程调试</span>
        </li>
        <li class="animated  fadeInRightBig">
          <img src="../assets/images/icons_4.png" alt="" />
          <span>环保工程运营</span>
        </li>
        <li class="animated  fadeInRightBig">
          <img src="../assets/images/icons_5.png" alt="" />
          <span>环境监理</span>
        </li>
      </ul>
    </div>
    <div class="environment_protection_list warp" id="section3">
      <h3>环保咨询</h3>
      <p>
        高效解决问题，代理企业进行环境危机对应，致力于为企业提供专业的环保咨询服务
      </p>
      <ul>
        <li class="animated  fadeInLeftBig">
          <img src="../assets/images/icons_6.png" alt="" />
          <span>环境法律咨询</span>
        </li>
        <li class="animated  fadeInLeftBig">
          <img src="../assets/images/icons_7.png" alt="" />
          <span>环境技术咨询</span>
        </li>
        <li class="animated  fadeIn">
          <img src="../assets/images/icons_8.png" alt="" />
          <span>环境税务咨询</span>
        </li>
        <li class="animated  fadeInRightBig">
          <img src="../assets/images/icons_9.png" alt="" />
          <span>环境工程造价咨询</span>
        </li>
        <li class="animated  fadeInRightBig">
          <img src="../assets/images/icons_10.png" alt="" />
          <span>环保公益咨询</span>
        </li>
      </ul>
    </div>
    <div class="environment_protection_list_1" id="section4">
      <h3>绿色金融服务</h3>
      <ul class="warp">
        <li>
          <img src="../assets/images/bao.png" alt="" />
          <span>环保保险</span>
        </li>
        <li>
          <img src="../assets/images/zixun.png" alt="" />
          <span>金融机构环保咨询</span>
        </li>
        <li>
          <img src="../assets/images/touzi.png" alt="" />
          <span>环保投融资服务</span>
        </li>
      </ul>
    </div>
    <div class="environment_protection_list_2" >
      <ul>
        <li id="section5">
          <div>
            <p>
              环保培训
            </p>
            <span>
              企业高级环境管理培训班 —
              企业分管副总、环保机构主要负责人等，定期小班，含考察
              环境职业实践培训班 —
              校企联合，针对毕业生就业前培训，环保实践课程研发课程
              企业高级环境管理培训班 — 企业环保专业技术人员，定期大班
              政府环境管理培训 — 第三方购买服务
            </span>
          </div>
        </li>
        <li id="section6">
          <div>
            <p>
              环保产品集采
            </p>
            <span>
              细分行业类别，专业技术对接，精准设备选型，对企业所需环保产品采购管理，发挥平台优势，降低采购成本，实现环保产品采购的规范化、制度化、标准化，在保障设备质量的前提下，减少企业采购成本；快速实现终端对接。
            </span>
          </div>
        </li>
        <li id="section7">
          <div>
            <p>
              环保人才
            </p>
            <span>
              智污邦环保专家、环保专业人才、一线专业实操，适时适事对接，智享环保服务
            </span>
          </div>
        </li>
      </ul>
    </div>
    <div class="environment_protection_list_3 warp" id="section8">
      <h3>环保管家专业保障</h3>
      <ul class="warp">
        <li>
          <img src="../assets/images/tuandui.png" alt="" />
          <span>专家技术团队</span>
        </li>
        <li>
          <img src="../assets/images/keji.png" alt="" />
          <span>优质服务商</span>
        </li>
        <li>
          <img src="../assets/images/gongchang.png" alt="" />
          <span>标准化服务流程</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {getkeeper}from "@/api/coment"
import commBanner from "../common/commBanner";
import titleHead from "../common/titleHead";
import { formatTime } from '../utils';
export default {
  components: {
    commBanner,
    titleHead
  },
  data() {
    return {
      obj: {
        title: "环保管家",
        roleType:'',
        personalType:3,
      },
       keeper:[],
       kepp:{}
    };
  },
  created(){
    if(this.$store.state.user.userInfo != null){
      let type = this.$store.state.user.userInfo.type;
      this.obj.roleType = type;
    }
    this.getKeper();
  },
  mounted(){
    let id = this.$route.query.id;
    if(id){
      this.goAnchor('#'+id)
    }
  },
  methods:{
    //模拟锚点跳转
    goAnchor(selector) {
      let anchor = document.querySelector(selector);
      //document.documentElement.scrollTop = anchor.offsetTop;
      let total = anchor.offsetTop;

      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      // 获取当前滚动条与窗体顶部的距离
      let distance =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算每一小段的距离
      let step = total / 50;
      (function smoothDown() {
        if (distance < total) {
          distance += step; // 移动一小段
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance; // 设定每一次跳动的时间间隔为10ms
          setTimeout(smoothDown, 10);
        } else {
          // 限制滚动停止时的距离
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      })();
    },
    //获取列表
    getKeper(){
      getkeeper().then((res)=>{
        if(res.code == 0){
          this.keeper = res.data;
          this.kepp = res.data[0];
          this.getMate()
        }
      }).catch((err)=>{})
    },
     getMate(){
      var metas = document.getElementsByTagName("meta"); 
      // metas[0].name ="keyword" 
      // metas[0].content= data[0].seokeywords
      // metas[1].name ="description" 
      // metas[1].content=data[0].seodescription
       document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
    },
  }
};
</script>

<style scoped lang="less">
.environmental_housekeeper_content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
  .environmental_housekeeper_left {
    flex: 1;
    img {
      height: 83px;
    }
    p {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #343434;
      margin-bottom: 30px;
    }
    span {
      line-height: 2;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #9a9a9a;
    }
  }
  .environmental_housekeeper_right {
    position: relative;
    flex: 1;
    text-align: center;
    img {
      height: 450px;
      margin-left: 10px;
    }
    &::before {
      position: absolute;
      top: 130px;
      left: 30px;
      display: inline-block;
      width: 1px;
      height: 176px;
      content: "";
      background: rgba(0, 0, 0, 0.5);
    }
  }
}
.environmental_service {
  position: relative;
  width: 100%;
  height: 430px;
  margin-bottom: 100px;
  background: url("../assets/images/serve_bg.png") no-repeat center/100%;
  .environmental_service_top {
    position: absolute;
    top: 13%;
    right: 15%;
    width: 430px;

    h3 {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
    }
    p {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      border-bottom: 1px solid #ffff;
      padding-bottom: 10px;
    }
    .environmental_service_structure {
      display: flex;
      margin-top: 10px;
      justify-content: space-between;
      position: relative;
      .environmental_service_line {
        position: relative;
        width: 1px;
        height: 112px;
        background: #ffffff;
        margin-top: 20px;
        left: -20px;
        &::after {
          position: absolute;
          bottom: 0;
          display: inline-block;
          width: 48px;
          height: 1px;
          background: #ffff;
          content: "";
        }
        &::before {
          position: absolute;
          right: 0;
          display: inline-block;
          width: 48px;
          height: 1px;
          background: #ffff;
          content: "";
        }
      }
      ul {
        &:nth-child(1) {
          li {
            padding: 10px 20px;
            border: 1px solid #ffffff;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            margin-bottom: 10px;
            padding: 0 14px;
            line-height: 30px;
            &:last-of-type {
              margin-bottom: 0;
            }
          }
        }
        &:nth-of-type(2) {
          li {
            position: relative;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            margin-bottom: 9px;
            line-height: 30px;
            &:last-of-type {
              margin-bottom: 0;
              &::before {
                width: 0;
                height: 0;
              }
            }
            &::after {
              position: absolute;
              display: inline-block;
              width: 37px;
              height: 1px;
              background: #ffff;
              content: "";
              margin-right: 20px;
              vertical-align: middle;
              left: -40px;
              bottom: 15px;
            }
            &::before {
              position: absolute;
              display: inline-block;
              width: 1px;
              height: 40px;
              background: #ffff;
              content: "";
              margin-right: 20px;
              vertical-align: middle;
              left: -41px;
              bottom: -24px;
            }
          }
        }
      }
    }
  }
}
.environment_protection_list {
  text-align: center;
  margin-bottom: 100px;
  h3 {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }
  p {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin: 10px 0 40px;
  }
  ul {
    display: flex;
    justify-content: space-between;
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      &:nth-of-type(1) {
        img {
          width: 55px;
        }
        span {
          color: #fb863f;
        }
      }
      &:nth-of-type(2) {
        span {
          color: #ffc71e;
        }
      }
      &:nth-of-type(3) {
        span {
          color: #5ebd44;
        }
      }
      &:nth-of-type(4) {
        span {
          color: #3c94de;
        }
      }
      &:nth-of-type(5) {
        span {
          color: #ff7f7f;
        }
      }
      img {
        width: 60px;
        height: 50px;
        margin-bottom: 20px;
        transition: all 0.6s;
      }
      img:hover{
        cursor: pointer;
        transform: scale(1.2);
      }
      span {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
      }
    }
  }
}
.environment_protection_list_1 {
  width: 100%;
  padding: 70px 0;
  background: url("../assets/images/environmental_housekeeper_bg.png") no-repeat
    center;
  text-align: center;
  h3 {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #112d02;
    margin-bottom: 40px;
  }
  ul {
    display: flex;
    justify-content: space-around;
    li {
      width: 250px;
      height: 250px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #66b53e;
      border-radius: 50%;
      img {
        width: 70px;
        height: 70px;
        margin-bottom: 10px;
        transition: all 0.6s;
      }
      img:hover{
        cursor: pointer;
        transform: scale(1.2);
      }
      span {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
.environment_protection_list_2 {
  ul {
    li {
      width: 100%;
      height: 362px;
      padding: 45px 0;
      div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 60%;
        height: 100%;
        padding: 10px 15px 10px 12%;
        p {
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          margin-bottom: 10px;
        }
        span {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          line-height: 2;
        }
      }
      &:nth-of-type(1) {
        background: url("../assets/images/environmental_housekeeper_bg2.png")
          no-repeat center/cover;
        div {
          background: rgba(46, 134, 234, 0.5);
        }
      }
      &:nth-of-type(2) {
        background: url("../assets/images/environmental_housekeeper_bg3.png")
          no-repeat center/cover;
        div {
          background: rgba(27, 147, 12, 0.5);
        }
      }
      &:nth-of-type(3) {
        background: url("../assets/images/environmental_housekeeper_bg4.png")
          no-repeat center/cover;
        div {
          background: rgba(255, 138, 0, 0.5);
        }
      }
    }
  }
}
.environment_protection_list_3 {
  width: 100%;
  padding: 70px 0;
  text-align: center;
  h3 {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 1;
    margin-bottom: 40px;
    &:before {
      display: inline-block;
      content: "";
      width: 5px;
      height: 17px;
      background: #ff7302;
      margin-right: 5px;
    }
  }
  ul {
    display: flex;
    justify-content: space-around;
    li {
      width: 210px;
      height: 210px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      &:nth-of-type(1) {
        background: linear-gradient(
          144deg,
          rgba(209, 235, 88, 1),
          rgba(68, 162, 49, 1)
        );
      }
      &:nth-of-type(2) {
        background: linear-gradient(
          -24deg,
          rgba(255, 137, 15, 1),
          rgba(254, 195, 15, 1)
        );
      }
      &:nth-of-type(3) {
        background: linear-gradient(
          -24deg,
          rgba(47, 203, 254, 1),
          rgba(48, 138, 253, 1)
        );
      }
      img {
        width: 60px;
        height: 60px;
        margin-bottom: 10px;
        transition: all 0.6s;
      }
      img:hover{
        cursor: pointer;
        transform:scale(1.2);
      }
      span {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/environmental_housekeeper.vue